/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';

//servies
import { ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { InaxAlarmConfig } from './../../alarm/src/config/alarmConfig';
import { InaxAlarmService } from './../../alarm/src/alarm';
import { ALARM_ROUTES } from './alarmUi.routing';
import { HistoricalAlarmListComponent } from './alarmList/historical-alarm-list.component';
import { InaxTranslatePipe } from './../../translate/src/pipe';
import { InaxConfiguration } from './../../common/src/inaxConfiguration';
import { InaxLoggerService } from './../../logger/src/logger';
import { TranslateModule } from './../../translate/src/translate.module';
import { CommonUiModule } from './../../commonUi/src/commonUi.module';
import { AlarmUiResourceManager } from './resources/resource.service';
import { PendingAlarmListComponent } from './alarmList/pending-alarm-list.component';
import { AlarmLineComponent } from './alarmLine/alarm-line.component';


@NgModule({
    imports:
    [
        //Modules
        BrowserModule,
        FormsModule,
        HttpModule,
        TranslateModule,
        CommonUiModule,
        ALARM_ROUTES
    ],
    exports:
    [
        AlarmLineComponent
    ],
    declarations:
    [
        //Components
        HistoricalAlarmListComponent,
        PendingAlarmListComponent,
        AlarmLineComponent
    ],
    providers:
    [
        //Services
        InaxConfiguration,
        InaxAlarmConfig,
        InaxAlarmService,
        AlarmUiResourceManager
    ],
    bootstrap: []
})

export class AlarmUiModule { 
        //Resource manager adds the translations to the translationservice
    constructor(private _resourceManager: AlarmUiResourceManager ) {}
}